import { render } from "./RowsList.vue?vue&type=template&id=58726db6&scoped=true"
import script from "./RowsList.vue?vue&type=script&lang=js"
export * from "./RowsList.vue?vue&type=script&lang=js"

import "./RowsList.vue?vue&type=style&index=0&id=58726db6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58726db6"]])

export default __exports__